import AssignedStopRow from './container';

export default AssignedStopRow;
